<template>
  <div>
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showFormList" @click.self="showFormList = false">
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Processar Lote {{ formData.lote }}</span>
            <button class="esocial-modal__close" @click="showFormList = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <div class="processar-actions">
              <button class="esocial-search__btn esocial-search__btn--primary" @click="onRegister(null)">
                <i class="fa fa-paper-plane"></i> Processar Lote
              </button>
            </div>

            <esocial-tabela
              :tableHead="tableHead"
              :tableData="tableData"
              :loadingTable="loadingContent"
              :pagination="pagination"
              :onSearch="getEsocialLotesProcessar"
              :disableCheckAll="true"
            />
          </div>
        </div>
      </div>
    </transition>

    <!--TIPO MODO -->
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay esocial-modal-overlay--nested" v-if="showModo" @click.self="showModo = false">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Selecione o modo de transmissão do arquivo</span>
            <button class="esocial-modal__close" @click="showModo = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <div class="modo-info">
              <div class="modo-info__row">
                <b>Inclusão</b>
                <span>Selecione esta opção na primeira vez que enviar o lote ou quando a tentativa de inclusão foi rejeitada.</span>
              </div>
              <div class="modo-info__row">
                <b>Alteração</b>
                <span>Selecione esta opção para alterar o evento. Nesse ponto deve existir um lote de inclusão enviado.</span>
              </div>
            </div>

            <div
              v-if="tableData && tableData.length > 0"
              class="modo-ultimo"
              :class="{ 'modo-ultimo--erro': tableData[0]._data.status != '201' }"
            >
              <i
                class="fa"
                :class="tableData[0]._data.status == '201' ? 'fa-check-circle' : 'fa-exclamation-triangle'"
              ></i>
              <div>
                <b>Último lote enviado:</b>
                {{ parseModo(tableData[0]._data.modo) }} em {{ toDate(tableData[0]._data.created_at, false) }}
                <div v-if="tableData[0]._data.status != '201'" class="modo-ultimo__aviso">
                  Lote não processado. Verifique o detalhamento do processamento.
                </div>
              </div>
            </div>

            <div class="modo-options">
              <button class="modo-option modo-option--inclusao" @click="onRegister(null, 'inc')">
                <i class="fa fa-plus-circle"></i>
                <span class="modo-option__title">Inclusão</span>
                <span class="modo-option__desc">Primeiro envio do lote, ou reenvio após rejeição.</span>
              </button>

              <button
                v-if="formData && formData.layout != 'S-3000'"
                class="modo-option modo-option--alteracao"
                @click="onRegister(null, 'alt')"
              >
                <i class="fa fa-pencil"></i>
                <span class="modo-option__title">Alteração</span>
                <span class="modo-option__desc">Altera um evento já incluído anteriormente.</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--STATUS PROCESSAMENTO -->
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay esocial-modal-overlay--nested" v-if="showLogs" @click.self="showLogs = false">
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">
              Status processamento {{ formDataLogs.protocolo ? formDataLogs.protocolo : "" }}
            </span>
            <button class="esocial-modal__close" @click="showLogs = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <div class="processar-log">
              <div
                v-for="(retorno, i) in formDataLogs.log_retorno"
                :key="i"
                class="processar-log__item"
                :class="
                  retorno.ocorrencias && retorno.ocorrencias.length
                    ? 'processar-log__item--error'
                    : 'processar-log__item--success'
                "
              >
                <div
                  class="processar-log__status"
                  :class="{ 'processar-log__status--error': retorno.ocorrencias && retorno.ocorrencias.length }"
                >
                  <i
                    class="fa"
                    :class="retorno.ocorrencias && retorno.ocorrencias.length ? 'fa-exclamation-triangle' : 'fa-check-circle'"
                  ></i>
                  <b>{{ retorno.cdResposta }}</b>
                  <span>{{ retorno.descResposta }}</span>
                </div>

                <div v-if="retorno.uid" class="processar-log__arquivo">
                  <div class="processar-log__arquivo-row">
                    <i class="fa fa-file-text-o"></i> <b>{{ retorno.uid }}</b>
                  </div>
                  <div v-if="retorno.recibo" class="processar-log__arquivo-recibo">
                    <i class="fa fa-check"></i> Recibo: {{ retorno.recibo }}
                  </div>
                  <div v-if="retorno.funcionario" class="processar-log__arquivo-funcionario">
                    {{ retorno.funcionario }}
                  </div>
                </div>

                <div v-if="retorno.ocorrencias && retorno.ocorrencias.length" class="processar-log__ocorrencias">
                  <div v-for="(ocorrencia, j) in retorno.ocorrencias" :key="j" class="processar-log__ocorrencia">
                    <b>{{ ocorrencia.codigo }}</b> {{ ocorrencia.descricao }}
                    <span v-if="ocorrencia.localizacao" class="processar-log__ocorrencia-loc">
                      em {{ ocorrencia.localizacao }}
                    </span>
                  </div>
                </div>
              </div>

              <div v-if="!formDataLogs.log_retorno || !formDataLogs.log_retorno.length" class="processar-log__empty">
                Nenhum detalhe de envio disponível.
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--ON LOGS -->
    <transition name="esocial-modal-fade">
      <div
        class="esocial-modal-overlay esocial-modal-overlay--nested"
        v-if="showLogsReq"
        @click.self="showLogsReq = false"
      >
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">{{ titleLogsReq }} Lote {{ formData.lote }}</span>
            <button class="esocial-modal__close" @click="showLogsReq = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <pre class="xml-viewer">{{ formatXml(messageLogsReq) }}</pre>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EsocialTabela from "../../includes/tabela";

export default {
  name: "esocial-lotes-processar",
  mixins: [],
  components: { EsocialTabela },
  inject: ["parent"],
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },

  watch: {
    formData() {
      this.getEsocialLotesProcessar();
    },

    showForm() {
      this.showFormList = !this.showFormList;
    },
  },

  data() {
    return {
      loadingContent: false,
      showFormList: false,
      showLogs: false,
      showModo: false,
      titleLogsReq: null,
      showLogsReq: false,
      messageLogsReq: null,
      pagination: {},
      formDataLogs: {},
      tableHead: [
        {
          key: "id",
          sortable: true,
          width: "150px",
          bold: true,
          label: "ID",
        },
        {
          key: "modo",
          label: "Modo",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "mensagem",
          label: "Mensagem",
        },
        {
          key: "protocolo",
          label: "Protocolo",
        },
        {
          key: "data_recepcao",
          label: "Data Recepção",
        },
        {
          key: "data_envio",
          label: "Data Envio",
        },
      ],
      tableData: [],
    };
  },

  mounted() {
    this.getEsocialLotesProcessar();
  },

  methods: {
    toDate: function (date, disabledHours) {
      return this.$utilidade.toDate(date, disabledHours);
    },

    formatXml(xml) {
      if (!xml) return "";

      var formatted = "";
      var pad = 0;

      xml
        .replace(/(>)(<)(\/*)/g, "$1\r\n$2$3")
        .split("\r\n")
        .forEach((node) => {
          var indent = 0;

          if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
          } else if (node.match(/^<\/\w/)) {
            if (pad !== 0) pad -= 1;
          } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
            indent = 1;
          }

          formatted += "  ".repeat(Math.max(0, pad)) + node + "\r\n";
          pad += indent;
        });

      return formatted.trim();
    },

    getEsocialLotesProcessar() {
      if (!this.formData.id) return;

      this.loadingContent = true;

      this.$root.$request
        .get("esocial/lotes/processar/" + this.formData.id)
        .then((result) => {
          this.loadingContent = false;

          if (result.status == 200) {
            this.formataLista(result);
          }
        });
    },

    onRegister(data, modo) {
      if (!modo) {
        this.showModo = !this.showModo;
        return;
      }

      let self = this;
      this.$root.$dialog
        .confirm("Tem certeza que deseja enviar esse lote para o eSocial?")
        .then(() => {
          self.$root.$loading.set(true);

          self.$root.$request
            .get(
              "esocial/lotes/processar/" +
                self.formData.id +
                "/enviar-lote/" +
                modo
            )
            .then((result) => {
              self.$root.$loading.set(false);

              if (result.status == 200) {
                self.formataLista(result);
                self.showModo = false;
              } else if (result.msg) {
                self.$root.$dialog.alert(result.msg, "error");
              }
            });
        });
    },

    onAtualizarProtocolo(data) {
      this.loadingContent = true;

      this.$root.$request
        .get(
          "esocial/lotes/processar/" +
            this.formData.id +
            "/" +
            data.id +
            "/consultar-lote"
        )
        .then((result) => {
          this.loadingContent = false;

          if (result.status == 200) {
            this.formataLista(result);
            this.parent.getEsocialLotes();
          } else if (result.msg) {
            this.$alert(result.msg, "Atenção", {
              confirmButtonText: "OK",
            });
          }
        });
    },

    onLogs(data) {
      this.formDataLogs = data;
      this.showLogs = !this.showLogs;
    },

    onLogsReqSend(data) {
      this.titleLogsReq = "Dados enviados";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_request;
    },

    onLogsReqReceiv(data) {
      this.titleLogsReq = "Dados recebidos";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_response;
    },

    parseModo: function (modo) {
      if (!modo) return;

      return modo
        .replace("INC", "Inclusão")
        .replace("ALT", "Alteração")
        .replace("EXC", "Exclusão");
    },

    formataLista(result) {
      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].loading = false;
        arrData[i].log_retorno = arrData[i].log_retorno
          ? this.$utilidade.stringToArray(arrData[i].log_retorno)
          : null;

        var item = {
          id: arrData[i].id,
          modo: this.parseModo(arrData[i].modo),
          status: arrData[i].status,
          mensagem: arrData[i].msg,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          request: arrData[i].request,
          response: arrData[i].response,
          data_recepcao: this.$utilidade.toDate(
            arrData[i].data_recepcao,
            false
          ),
          data_envio: this.$utilidade.toDate(arrData[i].created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {},
        };

        item.buttons.push({
          icon: "fa fa-refresh",
          color: "primary",
          title: "Consultar Protocolo",
          click: this.onAtualizarProtocolo,
        });

        if (arrData[i].log_retorno && arrData[i].log_retorno.length > 0) {
          item.buttons.push({
            icon: "fa fa-search",
            color: "warning",
            title: "Detalhes do Envio",
            click: this.onLogs,
          });

          if (arrData[i].log_request) {
            item.buttons.push({
              icon: "fa fa-cloud-upload",
              color: "warning",
              title: "Visualizar dados enviados",
              click: this.onLogsReqSend,
            });
          }

          if (arrData[i].log_response) {
            item.buttons.push({
              icon: "fa fa-cloud-download",
              color: "warning",
              title: "Visualizar dados recebidos",
              click: this.onLogsReqReceiv,
            });
          }
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;

  &--nested {
    z-index: 1600;
  }
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--wide {
    width: 90%;
    max-width: 1100px;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}

.processar-actions {
  display: flex;
  margin-bottom: 12px;
}

.modo-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.modo-info__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;

  b {
    color: #1f2329;
  }

  span {
    color: #6b7280;
  }
}

.modo-ultimo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(26, 138, 62, 0.08);
  color: #1a8a3e;
  font-size: 12px;
  margin-bottom: 20px;

  i {
    margin-top: 2px;
  }

  &--erro {
    background: rgba(192, 57, 43, 0.08);
    color: #c0392b;
  }
}

.modo-ultimo__aviso {
  margin-top: 4px;
  font-size: 11px;
}

.modo-options {
  display: flex;
  gap: 14px;
}

.modo-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 22px 16px;
  border: 1.5px solid #eef0f2;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;

  i {
    font-size: 24px;
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
    transform: translateY(-2px);
  }

  &--inclusao {
    color: #1a8a3e;

    &:hover {
      border-color: rgba(26, 138, 62, 0.5);
    }
  }

  &--alteracao {
    color: #09f;

    &:hover {
      border-color: rgba(0, 153, 255, 0.5);
    }
  }
}

.modo-option__title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2329;
}

.modo-option__desc {
  font-size: 11px;
  color: #6b7280;
  font-weight: 400;
}

.processar-log {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.processar-log__item {
  border: 1px solid rgba(168, 121, 31, 0.45);
  border-radius: 10px;
  padding: 14px 16px;

  &--success {
    border-color: rgba(26, 138, 62, 0.4);
  }

  &--error {
    border-color: rgba(192, 57, 43, 0.4);
  }
}

.processar-log__status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #1a8a3e;

  i {
    font-size: 13px;
  }

  &--error {
    color: #c0392b;
  }
}

.processar-log__arquivo {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fdf8ee;
  border-radius: 8px;
  font-size: 12px;
}

.processar-log__arquivo-row {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1f2329;
}

.processar-log__arquivo-recibo {
  margin-top: 4px;
  color: #1a8a3e;
  font-weight: 600;
}

.processar-log__arquivo-funcionario {
  margin-top: 2px;
  color: #6b7280;
}

.processar-log__ocorrencias {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.processar-log__ocorrencia {
  padding: 8px 10px;
  background: rgba(192, 57, 43, 0.08);
  border-radius: 6px;
  font-size: 12px;
  color: #c0392b;
}

.processar-log__ocorrencia-loc {
  color: #8a8f98;
  font-style: italic;
}

.processar-log__empty {
  text-align: center;
  color: #9aa0a8;
  padding: 20px 0;
}

.xml-viewer {
  white-space: pre-wrap;
  word-break: break-word;
  background: #fafbfc;
  border: 1px solid #eef0f2;
  border-radius: 8px;
  padding: 14px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 11px;
  line-height: 1.5;
  color: #1f2329;
  max-height: 60vh;
  overflow-y: auto;
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--primary {
    color: #fff;
    border-color: rgb(168, 121, 31);
    background: rgb(168, 121, 31);

    &:hover {
      background: rgb(148, 106, 27);
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1f0a837e